import { useState } from 'react';
import {
  useLaunchParams,
  useRawInitData,
  type RetrieveLPResultCamelCased,
} from '@telegram-apps/sdk-react';

export function DebugPanel() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState<string | null>(null);

  let lp: RetrieveLPResultCamelCased | null = null;
  let lpError: string | null = null;
  try {
    lp = useLaunchParams(true);
  } catch (e) {
    lpError = e instanceof Error ? e.message : String(e);
  }

  let rawInitData: string | undefined;
  try {
    rawInitData = useRawInitData();
  } catch {
    rawInitData = undefined;
  }

  const user = lp?.tgWebAppData?.user;

  const copy = async (label: string, value: string) => {
    await navigator.clipboard.writeText(value);
    setCopied(label);
    setTimeout(() => setCopied(null), 1500);
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(0, 0, 0, 0.85)',
        color: '#fff',
        fontFamily: 'ui-monospace, SFMono-Regular, monospace',
        fontSize: 12,
        zIndex: 9999,
        maxHeight: '50vh',
        overflowY: 'auto',
      }}
    >
      <div
        onClick={() => setOpen((v) => !v)}
        style={{
          padding: '6px 12px',
          cursor: 'pointer',
          background: 'rgba(255, 255, 255, 0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>🛠 Debug {user ? `(@${user.username ?? user.id})` : ''}</span>
        <span>{open ? '▼' : '▲'}</span>
      </div>

      {open && (
        <div style={{ padding: 12 }}>
          {lpError && <div style={{ color: '#ff6b6b' }}>Error: {lpError}</div>}

          {lp && (
            <>
              <div style={{ marginBottom: 8 }}>
                <strong>Platform:</strong> {lp.tgWebAppPlatform} | <strong>Version:</strong>{' '}
                {lp.tgWebAppVersion}
              </div>

              {user && (
                <div style={{ marginBottom: 8 }}>
                  <strong>User:</strong>
                  <pre style={{ margin: '4px 0', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                    {JSON.stringify(user, null, 2)}
                  </pre>
                </div>
              )}

              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                <button
                  onClick={() =>
                    rawInitData && copy('raw', rawInitData)
                  }
                  disabled={!rawInitData}
                  style={btnStyle(!rawInitData)}
                >
                  {copied === 'raw' ? '✓ Copied' : 'Copy raw initData'}
                </button>
                <button
                  onClick={() => lp && copy('json', JSON.stringify(lp, null, 2))}
                  style={btnStyle(false)}
                >
                  {copied === 'json' ? '✓ Copied' : 'Copy launch params (JSON)'}
                </button>
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', marginTop: 6 }}>
                Use "raw initData" for <code>Authorization: tma &lt;value&gt;</code>.
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

function btnStyle(disabled: boolean): React.CSSProperties {
  return {
    padding: '4px 12px',
    background: disabled ? 'rgba(255,255,255,0.1)' : '#3390ec',
    color: '#fff',
    border: 'none',
    borderRadius: 4,
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: 12,
    opacity: disabled ? 0.5 : 1,
  };
}
